import { HttpClient, HttpParams } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { ResponseDto } from "../../../models/response-dto.model";
import { Paginate } from "../../../models/pagination.model";
import { Tenant } from "../models/tenant.model";

@Injectable({
  providedIn: 'root',
})
export class PlatformManagerService {
  private readonly http = inject(HttpClient);

  getTenants(
    page: number,
    pageSize: number,
  ): Observable<Paginate<Tenant>> {
    let params = new HttpParams();
    params = params.set('page', page);
    params = params.set('pageSize', pageSize);

    return this.http
      .get<ResponseDto<Paginate<Tenant>>>(`/management-tenants`, { params })
      .pipe(map((response) => response.data));
  }

  loadTenant(tenant: string): Observable<Tenant> {
    return this.http
      .get<ResponseDto<Tenant>>(`/management-tenants/`+tenant, {})
      .pipe(map((response) => response.data));
  }
}
